// extracted by mini-css-extract-plugin
export default {"row":"Cart_row__4EUBC","col":"Cart_col__9DjjJ","cartItem":"Cart_cartItem__rhdlM","price":"Cart_price__FzTob","items":"Cart_items__srXim"};